import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getItemOrderAllocationByItem } from '../../../api/inventory/get-item-order-allocations-by-item'

/* Initial state of the slice */
const initialState = {
  isFetchingOrderAllocationsSummary: false,
  orderAllocationsSummary: [],
  fetchOrderAllocationsSummaryError: null,
}
/* Handler for making service call to fetch Customer Group for a specific item */
export const fetchOrderAllocationsSummary = createAsyncThunk(
  'orderAllocationsSummary/fetchOrderAllocationsSummary',
  async (args, { getState, rejectWithValue }) => {
    const state = getState()
    const request = {
      itemNumber: state.inventory.selectedInventoryItem.itemNumber.replaceAll('#', '%23'),
    }
    try {
      const response = await getItemOrderAllocationByItem(request)
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const orderAllocationsSummarySlice = createSlice({
  name: 'orderAllocationsSummary',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderAllocationsSummary.pending, (state) => {
        state.isFetchingOrderAllocationsSummary = true
        state.orderAllocationsSummary = []
        state.fetchOrderAllocationsSummaryError = null
      })
      .addCase(fetchOrderAllocationsSummary.fulfilled, (state, action) => {
        state.isFetchingOrderAllocationsSummary = false
        state.orderAllocationsSummary = action.payload
      })
      .addCase(fetchOrderAllocationsSummary.rejected, (state, action) => {
        state.isFetchingOrderAllocationsSummary = false
        state.fetchOrderAllocationsSummaryError = action.payload
      })
      .addCase('inventory/fetchInventoryItems/pending', (state) => {
        state.orderAllocationsSummary = []
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export default orderAllocationsSummarySlice.reducer
